import React from "react";
import { FaCheck, FaTimes } from "react-icons/fa";
import { PASSWORD_CRITERIA_ROWS } from "../utils/passwordCriteria";

const PasswordCriteriaList = ({ password = "" }) => (
  <ul className="bt-password-criteria" role="group" aria-label="Password requirements">
    {PASSWORD_CRITERIA_ROWS.map((criterion) => {
      const met = criterion.test(password);
      return (
        <li key={criterion.id} className={`bt-password-criteria-item${met ? " is-met" : ""}`}>
          <span className="bt-password-criteria-icon" aria-hidden="true">
            {met ? <FaCheck /> : <FaTimes />}
          </span>
          <span className="bt-password-criteria-label">{criterion.label}</span>
        </li>
      );
    })}
  </ul>
);

export default PasswordCriteriaList;
